import './contest-header.less';
import React, { Component } from 'react';

class FridayHeader extends Component {
	constructor(props) {
		super(props);
		this.state = { isPopupShowed: false };
		this.toggleFridayPopup = this.toggleFridayPopup.bind(this);
	}
	toggleFridayPopup() {
		this.setState((state) => ({...state, isPopupShowed: !state.isPopupShowed}));
	}
	render() {
		return (
			<a className='contest-2023 font-proxima-nova-semibold' href="https://contest.everad.com/">
				<div className="container contest-2023-pictures">
					<span className="title font-montserrat-black-normal">The wolf of everad</span>
					<span className="description font-montserrat-black-normal">
						New <span className="orange">contest</span> 2023
					</span>
					<span className="contest-2023-mercedes"></span>
					<span className="contest-2023-mini-cooper"></span>
					<span className="contest-2023-porsche"></span>
				</div>
			</a>
		);
	}
}
export default FridayHeader;


// WEBPACK FOOTER //
// ./frontend/cabinets/apps/everad/modules/header/contest-header.js